import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';

export default class MultiUnitCheck extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool,
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  handleOnCancel = (e) => {
    e.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel(e);
    }
  }
  render() {
    return (
      <Modal
        closeOnEscape={false}
        closeOnDimmerClick={false}
        open={this.props.open === true}
        size="small"
      >
        <Header icon="warning sign" content="Unsaved changes" />
        <Modal.Content>
          <Modal.Description>
            <p>You have unsaved changes. Do you still want to <strong>continue</strong>?</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic inverted negative onClick={this.handleOnCancel}>
            <Icon name="remove" /> No
          </Button>
          <Button basic inverted positive onClick={this.handleOnConfirm}>
            <Icon name="remove" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitCheck.jsx